"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAsideActionContent = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_1 = require("@veeam/components");
const matrixDescriptionRenderer_1 = require("./matrixDescriptionRenderer");
const LinkWrapper = styled_components_1.default.span `
  font-size: ${({ theme }) => theme.fonts.sizes.s};
`;
const getAsideActionContent = (textRenderer, texts, onBtnClick) => ({ rowIndex, data }) => (react_1.default.createElement(components_1.StackView, { direction: components_1.STACK_DIRECTION.row, distribution: components_1.STACK_DISTRIBUTION.start, gap: components_1.STACK_GAP.s, align: components_1.STACK_ALIGN.center },
    react_1.default.createElement(components_1.Text, { size: components_1.TEXT_SIZE.s, view: components_1.TEXT_VIEW.secondary }, matrixDescriptionRenderer_1.matrixDescriptionRenderer({
        textEmpty: texts.descriptionEmpty,
        textRenderer,
    })({ rowIndex, data })),
    react_1.default.createElement(components_1.Button, { ui: components_1.BUTTON_VIEW.text, onClick: onBtnClick },
        react_1.default.createElement(LinkWrapper, null, texts.btnLabel))));
exports.getAsideActionContent = getAsideActionContent;
//# sourceMappingURL=getAsideActionContent.js.map